<div class="tile" [dir]="textDir">
  
    <div class="row" style="display: flex;justify-content: space-between;"> 
      <div style="width:97%;display: inherit;">
      <div style="width:29%">
        <div class="flexStart">
        <p class="tilesmTitle" style="margin-bottom: 5px;">{{'Tablet overview' | translate}}</p>
        <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
        <div style="margin-top: 20px;">
          <div style="margin: 20px 0px;">
            <div style="margin-top: 20px;text-align: center;">
              <div class="flexCenter"><img src="assets/images/desktop.PNG"  width="105px" height=""  align="center"/></div>
              <div class="marT20">
                <div *ngFor="let item of deviceOverview" class="spaceArnd">
                  <div *ngIf="item?.id=='Tablet'; else nodata">
                  <div style="font-size: 30px;">{{item?.deployed}}<span class="devices" >{{'Tablets' | translate}}</span></div>                
                  <div style="font-size: 30px;">{{item?.used}}<span class="devices" >{{'Used' | translate}}</span></div>
                  </div>                 
                </div>
                <ng-template #nodata>
                  <div style="font-size: 30px;">0 <span class="devices" >{{'Tablets' | translate}}</span></div>                
                  <div style="font-size: 30px;">0 <span class="devices" >{{'Used' | translate}}</span></div>
                </ng-template>
                <div *ngIf="deviceOverview.length==0" class="spaceArnd">
                  <ng-container>
                    <div style="font-size: 30px;">0 <span class="devices" >{{'Tablets' | translate}}</span></div>                
                    <div style="font-size: 30px;">0 <span class="devices" >{{'Used' | translate}}</span></div>
                    </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div style="margin: 10px 0px;">
          <div class="content">
            <div *ngIf="tabletConnectivity.length!=0; else notabletCondata">
              <ng-container *ngFor="let item of tabletConnectivity">
                <div *ngIf="item?.id=='Tablet'">
                  <p style="display:block;height:30px;;margin-bottom: 15px;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'" *ngIf="item?.count>0 && item?.total>0 && !isNaN(item?.count) && !isNaN(item?.total)">{{math.round((item?.count/item?.total)*100)}}% <span class="devices">{{item?.id}} kk</span>
                  </p> 
                  <p style="display:block;height:30px;;margin-bottom: 15px;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'" *ngIf="item?.count==0 && item?.total==0">0% <span class="devices">{{item?.id}}</span>
                  </p>
                </div>               
                
              </ng-container>
              
             <!--  <ng-container *ngIf="tabletConnectivity.length==0">
                <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">Ethernet/Wi-FI/SIM</span>
                </p>
                <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">{{'No connection' | translate}}</span>
                </p> 
               
              </ng-container> -->
            </div>
            <ng-template #notabletCondata>
              <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">Ethernet/Wi-FI/SIM</span>
              </p>
              <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">{{'No connection' | translate}}</span>
              </p> 
            </ng-template>
          </div>
        </div>
      </div>
      <div class="verticalLine"></div>
      <div  style="width:30%">
        <div >
          <p class="tilesmTitle">{{'Utilisation' | translate}}</p>
         <!--  <ng-container *ngIf="tabletUtilization?.length">
          <div style="text-align: center;margin-top: 50px;" id="tabletUtilChart" [ctlDonutChart]='tabletUtilizationSetting' [ctlData]='tabletUtilization' [fontSize]='fontSmall'>
          </div>
        </ng-container> -->
        <div class="text-center padT30"> 
       <!--  <div id="percentagedonut1">Chart</div> -->
        <div class="text" *ngIf="tabletUtilization.length==0">{{'No data' | translate}}</div>
        <div class="chartContainer" disabled [ngClass]="tabletUtilization.length==0 ? 'chartDisabled':''">          
        <div id="percentagedonut1" >{{'Chart' | translate}}</div>
      </div>
        </div>
          <div class="content" style="margin: auto; text-align: center;">
            <!-- <p *ngFor="let item of tabletUtilization; let i = index" [attr.data-index]="i">
              <span [style.color]="tabletUtilizationSetting?.colors[i]">
                <i class="icon icon-alarm-level5"></i>
              </span>
              <span class="devices">Tablets {{item?.id}}</span>
            </p>  -->
         <!--    <div class="labels" style="display: flex;justify-content: center;">
              <div style="display: inline;padding:0px 10px" *ngFor="let item of tabletUtilization; let i = index" [attr.data-index]="i">
               
                <div style="display: inline;" [style.color]="tabletUtilizationSetting?.colors[i]"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" >{{item?.id}}</div>
               
              </div>             
            </div>   -->
                    
          </div>
        </div>   
      </div>
      <div class="verticalLine"></div>
      <div style="width: 30%;" >
      <div >
        <p class="tilesmTitle">{{'Connectivity' | translate}}</p>
        <!-- <ng-container *ngIf="tabletConnectivity?.length">
        <div style="text-align: center;margin-top: 50px;" id="tabletConnectChart" [ctlDonutChart]='tabletConnectivitySetting' [ctlData]='tabletConnectivity' [fontSize]='fontSmall'>
        </div>
        </ng-container> -->
        <div class="text-center padT30"> 
          <div class="text" *ngIf="tabletConnectivity.length==0 ">{{'No data' | translate}}</div>
          <div class="chartContainer" disabled [ngClass]="tabletConnectivity.length==0 ? 'chartDisabled':''">          
          <div id="percentagedonut2">{{'Chart' | translate}}</div>
        </div>
        </div>
       <!--  <hr>
        <div class="content" style="margin: auto; text-align: center;">
           
            <div class="labels" style="display: flex;justify-content: space-around;">
              <div style="display: inline;" *ngFor="let item of tabletConnectivity; let i = index" [attr.data-index]="i">
               
                <div style="display: inline;" [style.color]="tabletConnectivitySetting?.colors[i]"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" >{{item?.id}}</div>
               
              </div>             
            </div>  
          </div> -->
      </div>
    </div>
  </div>

    <div style="width: 20px;margin-top:2px;text-align: right;">
      <div #tabletoverviewdrop class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div class="item" tabindex="0" (click)="generateCSV('devices-tablet')">{{'Export panel data(csv)' | translate}}</div>
          <!-- <div class="item" tabindex="0">{{'Export panel graphic(pdf)' | translate}}</div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  
  <div class="row" style="display: flex;justify-content: space-between;"> 
    <div style="width:97%;display: inherit;">
    <div style="width:29%">
      <div class="flexStart">
      <p class="tilesmTitle" style="margin-bottom: 5px;">{{'Laptop overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
      <div style="margin-top: 20px;">
        <div style="margin: 20px 0px;">
          <div style="margin-top: 10px;text-align: center;">
            <div class="flexCenter"><img src="assets/images/desktop.PNG"  width="105px" height=""  align="center"/></div>
            <div class="marT20">
              <div *ngFor="let item of deviceOverview" class="spaceArnd">
                <ng-container *ngIf="item?.id=='Laptop'; else noLaptopdata">
                <div style="font-size: 30px;">{{item?.deployed}} <span class="devices" >{{'Laptops' | translate}}</span></div>                
                <div style="font-size: 30px;">{{item?.used}} <span class="devices" >{{'Used' | translate}}</span></div>
                </ng-container>
              </div>
              <ng-template #noLaptopdata>
                <div style="font-size: 30px;">0 <span class="devices" >{{'Tablets' | translate}}</span></div>                
                <div style="font-size: 30px;">0 <span class="devices" >{{'Used' | translate}}</span></div>
              </ng-template>
              <div *ngIf="deviceOverview.length==0" class="spaceArnd">
                <ng-container >
                <div style="font-size: 30px;">0 <span class="devices" >{{'Laptops' | translate}}</span></div>                
                <div style="font-size: 30px;">0 <span class="devices" >{{'Used' | translate}}</span></div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div style="margin: 10px 0px;">
        <div class="content">
          <div *ngIf="laptopConnectivity.length!= 0; else noLaptopCondata">
            <ng-container *ngFor="let item of laptopConnectivity">
              <p style="display:block;height:30px;margin-bottom: 15px;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'" *ngIf="item?.count>0 && item?.total>0 !isNaN(item?.count) && !isNaN(item?.total)">{{math.round((item?.count/item?.total)*100)}}% <span class="devices">{{item?.id}}</span>
              </p>
              <p style="display:block;height:30px;margin-bottom: 15px;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'" *ngIf="item?.count==0">0% <span class="devices">{{item?.id}}</span>
              </p> 
              <!--<p style="display:block;height:30px;text-align: center;">{{math.round((item.noconnection/item.deployed)*100)}}%<span class="devices" >  No Connection</span>
              </p>-->
            </ng-container>
          <!--   <ng-container *ngIf="laptopConnectivity.length==0">
              <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">Ethernet/Wi-FI/SIM</span>
              </p>
              <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">{{'No connection' | translate}}</span>
              </p> 
             
            </ng-container> -->

          </div>
          <ng-template #noLaptopCondata>
            <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">Ethernet/Wi-FI/SIM</span>
            </p>
            <p style="display:block;height:30px;margin-bottom: 15px;width: 100%;" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">0% <span class="devices" [ngClass]="textDir=='ltr'?'marL5':'marR5'">{{'No connection' | translate}}</span>
            </p> 
          </ng-template>
        </div>
      </div>
    </div>
    <div class="verticalLine"></div>
    <div  style="width:30%">
      <div >
        <p class="tilesmTitle">{{'Utilisation' | translate}}</p>
   
        <div class="text-center padT30"> 
        
        <div class="text" *ngIf="laptopUtilization.length==0">{{'No data' | translate}}</div>
          <div class="chartContainer" disabled [ngClass]="laptopUtilization.length==0 ? 'chartDisabled':''">          
          <div id="percentagedonut3" >{{'Chart' | translate}}</div>
        </div>
        </div>
      
      </div>   
    </div>
    <div class="verticalLine"></div>
      <div style="width: 32%;" >
      <div >
        <p class="tilesmTitle">{{'Connectivity' | translate}}</p>
     
        <div class="text-center padT30"> 
          <div class="text" *ngIf="laptopConnectivity.length==0"><span >{{'No data' | translate}}</span></div>
          <div class="chartContainer" disabled [ngClass]="laptopConnectivity.length==0 ? 'chartDisabled':''">          
          <div id="percentagedonut4" >{{'Chart' | translate}}</div>
        </div>
        </div>
       
      </div>
    </div>
    </div>
    <div  style="max-width: 20px;">
      <div #laptopoverviewdrop class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div class="item" tabindex="0" (click)="generateCSV('devices-laptop')">{{'Export panel data(csv)' | translate}}</div>
         <!--  <div class="item" tabindex="0">{{'Export panel graphic(pdf)' | translate}}</div> -->
          <!-- <hr>
          <div class="item space-between">
            <div>Settings</div>
            <div><i class="icon icon-settings"></i></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div class="sm-4">
      <div class="flexStart">
      <p class="tilesmTitle" style="margin-bottom: 5px;">{{'User to device average' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
      <div style="margin-top: 20px;">
      </div>

      <div style="margin: 10px 0px;">
        <div class="header">
          <div class="left">
            <div class="" style="font-size: 13px;text-align: center;margin-top:50px;">
              <img src="assets/images/users.PNG" align="center"/>
            </div>
          </div>
        </div>
        <div class="content">
          <div>
            <ng-container >
              <p><span *ngIf="userPerDevice">{{userPerDevice}}</span><span *ngIf="!userPerDevice">0 </span>
                 <span class="devices" [ngClass]="textDir=='rtl'?'marR5':''"> {{'Unique users per device/day' | translate}}</span>
              </p>
            </ng-container>
            
          </div>
        </div>
      </div>
    </div>

    <div class="verticalLine"></div>

      <div class="sm-7" >
       
        <div style="width:100%; min-width:500px;" >
          <p class="tilesmTitle">{{'User to device trend' | translate}}</p>
      
          <div >
          
           
              <div class="text" *ngIf="usertoDeviceTrendChartData.length==0">{{'No data' | translate}}</div> 
              <div class="chartContainer" [ngClass]="usertoDeviceTrendChartData.length==0 ? 'chartDisabled':'chartEnabled'">          
              <div id="device-linechart" >{{'Chart' | translate}}</div>
           
      </div>

      
        </div>
        </div>   
      </div>
    </div>
      <div  style="width: 20px;">
        <div #usertodevicedrop class="dropdown more" data-type="click">
          <button class="btn clickable"><i class="icon icon-more"></i></button>
          <div class="menu right">
            <div class="item" tabindex="0" (click)="generateCSV('user-to-device')">{{'Export panel data(csv)' | translate}}</div>
            <!-- <div class="item" tabindex="0">{{'Export panel graphic(pdf)' | translate}}</div> -->
            <!-- <hr>
            <div class="item space-between">
              <div>Settings</div>
              <div><i class="icon icon-settings"></i></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div class="sm-11">
      <div class="flexStart">
      <p class="tileTitle" style="margin-bottom: 5px;">{{'Tablet daily use' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
      <!--   <div style="text-align: center;color: #181818;" class="usertoDeviceTrendChart" [ctlLineChart]='usertoDeviceTrendChartSetting' [ctlLineData]='usertoDeviceTrendChartData'>
      </div> -->
      <ng-container >
        <div class="content" style="text-align: center;">
          <!-- <p *ngFor="let item of tabletDailyUseKeys; let i = index" [attr.data-index]="i">
            <ng-container *ngIf="item !== 'date'">
              <span [style.color]="tabletDailyUseSetting?.colors[i]">
                <i class="icon icon-alarm-level5"></i>
              </span>
              <span class="devices">{{item}}</span>
            </ng-container>
          </p> -->
        <!--   <div class="labels" style="display: flex;justify-content: center;">
            <div style="margin-right: 20px;margin-left:0px;display: inline;" *ngFor="let item of tabletDailyUseKeys; let i = index" [attr.data-index]="i">
              <ng-container *ngIf="item !== 'date'">
              <div style="display: inline;" [style.color]="tabletDailyUseSetting?.colors[i]"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" >{{item}}</div>
              </ng-container>
            </div>             
          </div> -->
        </div>
        <div style="display: inline-block;margin-top: 20px; width:100%; min-width: 700px;">
          <!-- <div class="verticalTxt" style="margin-top:100px;margin-left:20px;">Minutes</div>
          <div style="margin-top:-200px;margin-left:50px; margin-bottom: 20px;text-align: center;color: #181818; font-family: Ericsson Hilda;" id="tabletDailyUseChart" [ctlBarChart]='tabletDailyUseSetting' [ctlBarData]='tabletDailyUseData'>
          </div> -->
          
          <div class="text" *ngIf="tabletDailyUseData.length==0">{{'No data' | translate}}</div>
          <div class="chartContainer" [ngClass]="tabletDailyUseData.length==0 ? 'chartDisabled':''">          
          <div id="stacked-chart1" >{{'Chart' | translate}}</div>
        </div>
        </div>
      </ng-container>
    </div>
  </div>
    <div  style="width: 20px;">
      <div #tabletusagedrop class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div class="item" tabindex="0" (click)="generateCSV('devices-tablet-usage')">{{'Export panel data(csv)' | translate}}</div>
          <!-- <div class="item" tabindex="0">{{'Export panel graphic(pdf)' | translate}}</div> -->
          <!-- <hr>
          <div class="item space-between">
            <div>Settings</div>
            <div><i class="icon icon-settings"></i></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
  <div class="sm-11">
    <div class="flexStart">
    <p class="tilesmTitle" style="margin-bottom: 5px;">{{'Laptop daily use' | translate}}</p>
    <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
    </div>
    <!-- <div style="text-align: center;color: #181818;" class="usertoDeviceTrendChart" [ctlLineChart]='usertoDeviceTrendChartSetting' [ctlLineData]='usertoDeviceTrendChartData'>
    </div> -->
    <ng-container >
      <div class="content" style="text-align: center;">
        <!-- <p *ngFor="let item of laptopDailyUseKeys; let i = index" [attr.data-index]="i">
          <ng-container *ngIf="item != 'date'">
            <span [style.color]="laptopDailyUseSetting?.colors[i]">
              <i class="icon icon-alarm-level5"></i>
            </span>
            <span class="devices" *ngIf="item !== 'date'">{{item}}</span>
          </ng-container>
        </p> -->
        <!-- <div class="labels" style="display: flex;justify-content: center;">
          <div style="margin-right: 20px;margin-left:0px;display: inline;" *ngFor="let item of laptopDailyUseKeys; let i = index" [attr.data-index]="i">
            <ng-container *ngIf="item !== 'date'">
            <div style="display: inline;" [style.color]="laptopDailyUseSetting?.colors[i]"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" >{{item}}</div>
            </ng-container>
          </div>             
        </div> -->
      </div>
      <div style="display: inline-block;margin-top: 20px; width:100%; min-width: 700px;">
       <!--  <div class="verticalTxt" style="margin-top:100px;margin-left:20px;">Minutes</div>
        <div style="margin-top:-200px;margin-left:50px; margin-bottom: 20px;text-align: center;color: #181818; font-family: Ericsson Hilda;" id="laptopDailyUseChart" [ctlBarChart]='laptopDailyUseSetting' [ctlBarData]='laptopDailyUseData'>
        </div> -->
        <div class="text" *ngIf="laptopDailyUseData.length==0">{{'No data' | translate}}</div>
        <div class="chartContainer" disabled [ngClass]="laptopDailyUseData.length==0 ? 'chartDisabled':''">          
        <div id="stacked-chart2" >{{'Chart' | translate}}</div>
      </div>
      </div>
    </ng-container>
  </div>
    </div>
  <div  style="width: 20px;">
    <div #laptopusagedrop class="dropdown more" data-type="click">
      <button class="btn clickable"><i class="icon icon-more"></i></button>
      <div class="menu right">
        <div class="item" tabindex="0" (click)="generateCSV('devices-laptop-usage')">{{'Export panel data(csv)' | translate}}</div>
       <!--  <div class="item" tabindex="0">{{'Export panel graphic(pdf)' | translate}}</div> -->
        <!-- <hr>
        <div class="item space-between">
          <div>Settings</div>
          <div><i class="icon icon-settings"></i></div>
        </div> -->
      </div>
    </div>
  </div>
  </div>
</div>

<br>

<div class="tile" style="height: auto;" [dir]="textDir">
  <div class="row" >
    <div style="width:100%; display: flex;justify-content: space-between;">
      <div style="width:97%;"> 
         <div class="text" *ngIf="inventoryReport[0].qty==0">{{'No data' | translate}}</div>
      <div class="chartContainer" [ngClass]="inventoryReport[0].qty==0 ? 'chartDisabled':''">
    <div class="sm-11">
      <div class="flexStart">
      <p class="tilesmTitle" style="margin-bottom: 5px;">{{'Device inventory' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
      <div class="content" style=" margin-left: 20px;padding-right: 10px;height:37px">
        <table class="table" [dir]="textDir">
          <thead style="color: #f2f2f2;">
            <tr style="color: #f2f2f2;opacity: 0.6;padding-left:20px;">
              <th>{{'Hardware description' | translate}}</th>
              <th>{{'Model' | translate}}</th>
              <th>{{'OS' | translate}}</th>
              <th>{{'Quantity' | translate}}</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="content" style="display: inline-block; margin-left: 20px;height:300px;overflow-y: auto;scrollbar-width: thin;">
        <table class="table dashed" [dir]="textDir">
         
          <tbody style="background-color: black; font-size:12px;">
            <tr *ngFor="let item of inventoryReport">
              <td>{{item?.manufacturerName}}</td>
              <td style="padding-left: 5px;">{{item?.modeNo}}</td>
              <td style="padding-left: 5px;">{{item?.osName}}</td>
              <td >{{item?.qty}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
    </div>
    <div  style="width: 20px;">
      <div #deviceinventorydrop class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div class="item" tabindex="0" (click)="generateCSV('device-inventory')">{{'Export panel data(csv)' | translate}}</div>
         <!--  <div class="item" tabindex="0">{{'Export panel graphic(pdf)' | translate}}</div> -->
          <!-- <hr>
          <div class="item space-between">
            <div>Settings</div>
            <div><i class="icon icon-settings"></i></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>